import script from "./HeaderProject.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderProject.vue?vue&type=script&setup=true&lang=js"

import "./HeaderProject.vue?vue&type=style&index=0&id=c9ac04f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9ac04f2"]])

export default __exports__